module.exports = __webpack_public_path__ + "static/media/dem_hot_cut.0ba6e8b5.png";